import { render, staticRenderFns } from "./PlaceHolderImage.vue?vue&type=template&id=292b98d2&"
import script from "./PlaceHolderImage.vue?vue&type=script&lang=ts&"
export * from "./PlaceHolderImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports